import React,{ useContext, useEffect, useMemo } from "react";
import { useSelector } from "react-redux";
import { createContext } from "react";
import * as Sentry from "@sentry/react";

const AuthContext = createContext(null);

export function AuthProvider({ children}) {
    const { me } = useSelector((store) => store.me);

    const isAuthenticated = !!me;

    useEffect(() => {
        if (me) {
            Sentry.setUser({
                id: me.id || 'no-id',
                email: me.email || me.id || 'no-email',
                username: me.phone || me.id || 'no-phone',
            });
        } else {
            Sentry.setUser(null);
        }
    }, [me]);

    const value = useMemo(() => ({ me, isAuthenticated }));
    return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>
}

export function useAuth() {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error("useAuth must be used within an AuthProvider");
    }
    return context;
}